'use strict';

var tslib_1 = require('tslib');
var util = require('../util');

var index = util.createSimpleFC({
    tag: 'button',
    name: 'button',
    className: function (_a) {
        var props = _a.props;
        return ['btn', {
                outline: util.hasProp(props.outline),
                disabled: util.hasProp(props.disabled),
                gradient: util.hasProp(props.gradient) && !util.hasProp(props.outline)
            }];
    },
    updateData: function (ctx) {
        if ('text' in ctx.props) {
            ctx.data.domProps = tslib_1.__assign({}, ctx.data.domProps, { innerText: ctx.props.text });
        }
        return ctx;
    }
});

module.exports = index;
